import { render, staticRenderFns } from "./footerBuild.vue?vue&type=template&id=fd2201c0"
import script from "./footerBuild.vue?vue&type=script&lang=js"
export * from "./footerBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports